import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const RiskRegisterUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // superuser role
  ownerUserId, onOwnerUserIdChange, ownerUserIdError, setOwnerUserIdError, ownerUserIdList,
  status, onStatusChange, statusError, setStatusError, statusList,
  mitigationPlan, onMitigationPlanChange, mitigationPlanError, setMitigationPlanError,
  remarks, onRemarksChange, remarksError, setRemarksError,
  riskLevel, onRiskLevelChange, riskLevelError, setRiskLevelError, riskLevelList,
  riskResponse, onRiskResponseChange, riskResponseError, setRiskResponseError, riskResponseList,
  probability, onProbabilityChange, probabilityError, setProbabilityError, probabilityList,
  impact, onImpactChange, impactError, setImpactError, impactList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update risk'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <div className='g_flex_h g_flex_top'>
      <div className='col'>
        <InputSelectSF type='select' name='ownerUserId' label='Risk owner'
          value={ownerUserId} onChange={onOwnerUserIdChange} optionList={ownerUserIdList}
          error={ownerUserIdError} setError={setOwnerUserIdError}
        />
        <InputSelectSF type='select' name='status' label='Risk status'
          value={status} onChange={onStatusChange} optionList={statusList}
          error={statusError} setError={setStatusError}
        />
        <InputTextSF type='select' name='mitigationPlan' label='Mitigation plan'
          value={mitigationPlan} onChange={onMitigationPlanChange}
          error={mitigationPlanError} setError={setMitigationPlanError}
        />
        <InputTextSF type='select' name='remarks' label='Remarks'
          value={remarks} onChange={onRemarksChange}
          error={remarksError} setError={setRemarksError}
        />
      </div>
      <div>
        <InputSelectSF type='select' name='probability' label='Probability'
          value={probability} onChange={onProbabilityChange} optionList={probabilityList}
          error={probabilityError} setError={setProbabilityError}
        />
        <InputSelectSF type='select' name='riskReponse' label='Risk Response'
          value={riskResponse} onChange={onRiskResponseChange} optionList={riskResponseList}
          error={riskResponseError} setError={setRiskResponseError}
        />
        <InputSelectSF type='select' name='riskLevel' label='Risk Level'
          value={riskLevel} onChange={onRiskLevelChange} optionList={riskLevelList}
          error={riskLevelError} setError={setRiskLevelError}
        />
        <InputSelectSF type='select' name='impact' label='Impact'
          value={impact} onChange={onImpactChange} optionList={impactList}
          error={impactError} setError={setImpactError}
        />
      </div>
    </div>

  </ModalFormUI>

export default RiskRegisterUpdateModalUI
